import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TenantInvite} from '../../data/tenantInvite';
import {ProblemDetails} from '../../../app-common/data/problemDetails';
import {CreateOrganizationRequest} from '../../data/createOrganizationRequest';
import {TenantService} from '../../services/tenant/tenant.service';
import {Router} from '@angular/router';
import {Tenant} from '../../data/tenant';
import {BasicCompanyInformation} from '../../data/registerTrialRequest';

@Component({
  selector: 'app-create-organization-form',
  templateUrl: './create-organization-form.component.html',
  styleUrls: ['./create-organization-form.component.scss']
})
export class CreateOrganizationFormComponent implements OnInit {
  @Input() openModal: EventEmitter<void>;
  // tslint:disable-next-line:no-output-native
  @Output() success: EventEmitter<Tenant> = new EventEmitter<Tenant>();
  organizationName: string = '';
  organizationDescription: string = '';
  invitations: TenantInvite[] = [TenantInvite.empty()];
  modalOpen: boolean = false;
  isSubmitting: boolean = false;
  noInvitation: boolean = false;
  problemDetails: ProblemDetails<CreateOrganizationRequest>;

  constructor(private tenantService: TenantService,
              private route: Router) {
  }

  get isFormValid() {
    return this.organizationName.length > 0 && !this.isSubmitting;
  }

  isEmailValid(email: string) {
    return email.match(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
  }

  isFirstNameValid(firstName: string) {
    return firstName.length > 0;
  }

  isLastNameValid(lastName: string) {
    return lastName.length > 0;
  }

  isInvitationValid(invitation: TenantInvite) {
    return this.isEmailValid(invitation.email) && this.isFirstNameValid(invitation.firstName) && this.isLastNameValid(invitation.lastName);
  }

  areAllInvitationsValid() {
    return this.invitations.every(invitation => this.isInvitationValid(invitation));
  }

  ngOnInit(): void {
    if (this.openModal) {
      this.openModal.subscribe(() => {
        this.modalOpen = true;
      });
    }
  }

  addInvitation() {
    this.invitations.push(TenantInvite.empty());
  }

  removeInvitation(index: number) {
    this.invitations.splice(index, 1);
  }

  checkNoInvitation() {
    if (this.invitations.length === 1 && this.invitations[0].email === '' && this.invitations[0].firstName === '' && this.invitations[0].lastName === '') {
      this.noInvitation = true;
      return;
    }
    this.saveNewOrganization();
    this.noInvitation = false;
  }

  async saveNewOrganization() {
    this.isSubmitting = true;
    this.noInvitation = false;
    const request = new CreateOrganizationRequest();
    request.companyInformation = new BasicCompanyInformation();
    request.companyInformation.companyName = this.organizationName;
    request.companyInformation.companyDescription = this.organizationDescription;
    this.invitations.forEach((x, index) => {
      if (!this.isInvitationValid(x)) {
        this.removeInvitation(index);
      }
    });
    request.users = this.invitations;
    for (const user of request.users) {
      user.role = 'User';
    }
    this.tenantService.createTenant(request).then((organization) => {
      this.modalOpen = false;
      this.organizationName = '';
      this.organizationDescription = '';
      this.invitations = [TenantInvite.empty()];

      this.success.emit(organization);
    }).catch(e => {
      if (e instanceof ProblemDetails) {
        this.problemDetails = e;
      }
    }).finally(() => {
      this.isSubmitting = false;
    });
  }

  cancelNewOrganization() {
    this.modalOpen = false;
  }

  getUserProblemDetailsKey(i: number) {
    return `users[${i}]`;
  }
}
